import { useMutation } from '@apollo/client';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useToaster } from '../../../core/components/Toast.tsx';
import { VoiceAgentFormData } from '../components/ConfigSteps.tsx';
import { CREATE_VOICE_AGENT, UPLOAD_VOICE_AGENT_KNOWLEDGE_FILE } from '../queries.ts';
import { transformVoiceAgentFormData } from '../utils/transformVoiceAgentFormData.ts';

export const useCreateVoiceAgent = () => {
    const { t } = useTranslation('voice_agents');
    const { publishToast } = useToaster();
    const [createVoiceAgentMutation] = useMutation(CREATE_VOICE_AGENT, { refetchQueries: ['GetNavigationAgents'] });
    const [uploadKnowledgeFile] = useMutation(UPLOAD_VOICE_AGENT_KNOWLEDGE_FILE);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const createVoiceAgent = async (data: VoiceAgentFormData): Promise<string | null> => {
        setIsSubmitting(true);
        try {
            const { data: result } = await createVoiceAgentMutation({
                variables: { input: transformVoiceAgentFormData(data) },
            });
            const newAgent = result.createVoiceAgent.voiceAgent;

            const filesToUpload = (data.files || []).filter((f: any): f is File => f instanceof File);
            for (const file of filesToUpload) {
                await uploadKnowledgeFile({ variables: { configId: newAgent.id, file } });
            }

            publishToast({ description: t('createModal.createSuccess'), status: 'success' });
            return newAgent.id;
        } catch (error) {
            console.error(error);
            publishToast({ description: t('createModal.createError'), status: 'error' });
            return null;
        } finally {
            setIsSubmitting(false);
        }
    };

    return { createVoiceAgent, isSubmitting };
};
